// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type CompleteUploadRead,
  CompleteUploadReadFromJSON,
  CompleteUploadReadToJSON,
} from "../models/CompleteUploadRead";
import {
  type CursorPageFileList,
  CursorPageFileListFromJSON,
  CursorPageFileListToJSON,
} from "../models/CursorPageFileList";
import {
  type CursorPageHistory,
  CursorPageHistoryFromJSON,
  CursorPageHistoryToJSON,
} from "../models/CursorPageHistory";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import { type Description, DescriptionFromJSON, DescriptionToJSON } from "../models/Description";
import { type Directory, DirectoryFromJSON, DirectoryToJSON } from "../models/Directory";
import {
  type FileDownload,
  FileDownloadFromJSON,
  FileDownloadToJSON,
} from "../models/FileDownload";
import { type FileRead, FileReadFromJSON, FileReadToJSON } from "../models/FileRead";
import {
  type FileReadWithUrl,
  FileReadWithUrlFromJSON,
  FileReadWithUrlToJSON,
} from "../models/FileReadWithUrl";
import { type Upload, UploadFromJSON, UploadToJSON } from "../models/Upload";
import {
  type UploadComplete,
  UploadCompleteFromJSON,
  UploadCompleteToJSON,
} from "../models/UploadComplete";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface DatasetAbortUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  upload: Upload;
}

export interface DatasetCompleteUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  uploadComplete: UploadComplete;
}

export interface DatasetFileCopyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   * Source path
   */
  sourcePath: string;
  /**
   * Destination path
   */
  destinationPath: string;
  /**
   * Source reference in history
   */
  srcRef?: string;
  /**
   * Destination branch
   */
  branch?: string;
}

export interface DatasetFileDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
}

export interface DatasetFileHistoryRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  path?: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  cursor?: string | null;
}

export interface DatasetFileLsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  path?: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  cursor?: string | null;
}

export interface DatasetFileMoveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   * Source path
   */
  sourcePath: string;
  /**
   * Destination path
   */
  destinationPath: string;
  /**
   * Branch reference
   */
  branch?: string;
}

export interface DatasetFileStatRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  ref?: string;
}

export interface DatasetStartUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
}

export interface JobCompleteUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  uploadComplete: UploadComplete;
}

export interface JobDownloadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  ref?: string;
}

export interface JobFileHistoryRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  path?: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  cursor?: string | null;
}

export interface JobFileLsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  path?: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  cursor?: string | null;
}

export interface JobFileStatRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  ref?: string;
}

export interface JobStartUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  xJobSecret: string;
  /**
   *
   */
  branch?: string;
}

export interface ProjectDeleteDirectoryRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   * Branch reference
   */
  branch?: string;
}

export interface ProjectDirectoryCopyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * Source path
   */
  sourcePath: string;
  /**
   * Destination path
   */
  destinationPath: string;
  /**
   * Destination branch
   */
  branch?: string;
}

export interface ProjectDirectoryCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * Directory path
   */
  path: string;
  /**
   * Branch reference
   */
  branch?: string;
}

export interface ProjectDirectoryMoveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * Source path
   */
  sourcePath: string;
  /**
   * Destination path
   */
  destinationPath: string;
  /**
   * Branch reference
   */
  branch?: string;
}

export interface ProjectDownloadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  ref?: string;
}

export interface ProjectFileAbortUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  upload: Upload;
}

export interface ProjectFileCompleteUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  uploadComplete: UploadComplete;
}

export interface ProjectFileCopyRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * Source path
   */
  sourcePath: string;
  /**
   * Destination path
   */
  destinationPath: string;
  /**
   * Source reference in history
   */
  srcRef?: string;
  /**
   * Destination branch
   */
  branch?: string;
}

export interface ProjectFileDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
}

export interface ProjectFileHistoryRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path?: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  cursor?: string | null;
}

export interface ProjectFileLsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  offset?: number;
  /**
   *
   */
  orderBy?: ProjectFileLsOrderByEnum;
  /**
   *
   */
  orderByCaseSensitive?: boolean;
  /**
   *
   */
  path?: string;
  /**
   *
   */
  cursor?: string | null;
  /**
   *
   */
  ref?: string;
}

export interface ProjectFileMoveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * Source path
   */
  sourcePath: string;
  /**
   * Destination path
   */
  destinationPath: string;
  /**
   * Branch reference
   */
  branch?: string;
}

export interface ProjectFileRestartRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  ref?: string;
}

export interface ProjectFileSetDescriptionRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   * File path
   */
  path: string;
  /**
   *
   */
  description: Description;
  /**
   * Branch reference
   */
  branch?: string;
}

export interface ProjectFileStartUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  branch?: string;
}

export interface ProjectFileStatRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  projectId: string;
  /**
   *
   */
  path: string;
  /**
   *
   */
  ref?: string;
}

/**
 *
 */
export class FilesApi extends runtime.BaseAPI {
  /**
   * Creates request options for datasetAbortUpload without sending the request
   */
  async datasetAbortUploadRequestOpts(
    requestParameters: DatasetAbortUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetAbortUpload().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetAbortUpload().'
      );
    }

    if (requestParameters["upload"] == null) {
      throw new runtime.RequiredError(
        "upload",
        'Required parameter "upload" was null or undefined when calling datasetAbortUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["upload"]),
    };
  }

  /**
   * Abort a file upload and remove any uploaded files.
   * abort file upload
   */
  async datasetAbortUploadRaw(
    requestParameters: DatasetAbortUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.datasetAbortUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Abort a file upload and remove any uploaded files.
   * abort file upload
   */
  async datasetAbortUpload(
    requestParameters: DatasetAbortUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.datasetAbortUploadRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for datasetCompleteUpload without sending the request
   */
  async datasetCompleteUploadRequestOpts(
    requestParameters: DatasetCompleteUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetCompleteUpload().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetCompleteUpload().'
      );
    }

    if (requestParameters["uploadComplete"] == null) {
      throw new runtime.RequiredError(
        "uploadComplete",
        'Required parameter "uploadComplete" was null or undefined when calling datasetCompleteUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UploadCompleteToJSON(requestParameters["uploadComplete"]),
    };
  }

  /**
   * Complete the upload and associate the upload object with a path.
   * complete file upload
   */
  async datasetCompleteUploadRaw(
    requestParameters: DatasetCompleteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CompleteUploadRead>> {
    const requestOptions = await this.datasetCompleteUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompleteUploadReadFromJSON(jsonValue)
    );
  }

  /**
   * Complete the upload and associate the upload object with a path.
   * complete file upload
   */
  async datasetCompleteUpload(
    requestParameters: DatasetCompleteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CompleteUploadRead> {
    const response = await this.datasetCompleteUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetFileCopy without sending the request
   */
  async datasetFileCopyRequestOpts(
    requestParameters: DatasetFileCopyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetFileCopy().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetFileCopy().'
      );
    }

    if (requestParameters["sourcePath"] == null) {
      throw new runtime.RequiredError(
        "sourcePath",
        'Required parameter "sourcePath" was null or undefined when calling datasetFileCopy().'
      );
    }

    if (requestParameters["destinationPath"] == null) {
      throw new runtime.RequiredError(
        "destinationPath",
        'Required parameter "destinationPath" was null or undefined when calling datasetFileCopy().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["sourcePath"] != null) {
      queryParameters["source_path"] = requestParameters["sourcePath"];
    }

    if (requestParameters["destinationPath"] != null) {
      queryParameters["destination_path"] = requestParameters["destinationPath"];
    }

    if (requestParameters["srcRef"] != null) {
      queryParameters["src_ref"] = requestParameters["srcRef"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/copy`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Copy a file from one location to another in a branch.
   * copy file
   */
  async datasetFileCopyRaw(
    requestParameters: DatasetFileCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileRead>> {
    const requestOptions = await this.datasetFileCopyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadFromJSON(jsonValue));
  }

  /**
   * Copy a file from one location to another in a branch.
   * copy file
   */
  async datasetFileCopy(
    requestParameters: DatasetFileCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileRead> {
    const response = await this.datasetFileCopyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetFileDelete without sending the request
   */
  async datasetFileDeleteRequestOpts(
    requestParameters: DatasetFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetFileDelete().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetFileDelete().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling datasetFileDelete().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/delete`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a file.
   * delete a file
   */
  async datasetFileDeleteRaw(
    requestParameters: DatasetFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.datasetFileDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a file.
   * delete a file
   */
  async datasetFileDelete(
    requestParameters: DatasetFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.datasetFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for datasetFileHistory without sending the request
   */
  async datasetFileHistoryRequestOpts(
    requestParameters: DatasetFileHistoryRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetFileHistory().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetFileHistory().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/history`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Show history optionally filtered by file or directory.
   * show history
   */
  async datasetFileHistoryRaw(
    requestParameters: DatasetFileHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CursorPageHistory>> {
    const requestOptions = await this.datasetFileHistoryRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CursorPageHistoryFromJSON(jsonValue)
    );
  }

  /**
   * Show history optionally filtered by file or directory.
   * show history
   */
  async datasetFileHistory(
    requestParameters: DatasetFileHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CursorPageHistory> {
    const response = await this.datasetFileHistoryRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetFileLs without sending the request
   */
  async datasetFileLsRequestOpts(
    requestParameters: DatasetFileLsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetFileLs().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetFileLs().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/ls`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a listing of files in a directory.
   * list files
   */
  async datasetFileLsRaw(
    requestParameters: DatasetFileLsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CursorPageFileList>> {
    const requestOptions = await this.datasetFileLsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CursorPageFileListFromJSON(jsonValue)
    );
  }

  /**
   * Return a listing of files in a directory.
   * list files
   */
  async datasetFileLs(
    requestParameters: DatasetFileLsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CursorPageFileList> {
    const response = await this.datasetFileLsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetFileMove without sending the request
   */
  async datasetFileMoveRequestOpts(
    requestParameters: DatasetFileMoveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetFileMove().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetFileMove().'
      );
    }

    if (requestParameters["sourcePath"] == null) {
      throw new runtime.RequiredError(
        "sourcePath",
        'Required parameter "sourcePath" was null or undefined when calling datasetFileMove().'
      );
    }

    if (requestParameters["destinationPath"] == null) {
      throw new runtime.RequiredError(
        "destinationPath",
        'Required parameter "destinationPath" was null or undefined when calling datasetFileMove().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["sourcePath"] != null) {
      queryParameters["source_path"] = requestParameters["sourcePath"];
    }

    if (requestParameters["destinationPath"] != null) {
      queryParameters["destination_path"] = requestParameters["destinationPath"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/move`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Rename a file to a new location in a branch.
   * Move file
   */
  async datasetFileMoveRaw(
    requestParameters: DatasetFileMoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileRead>> {
    const requestOptions = await this.datasetFileMoveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadFromJSON(jsonValue));
  }

  /**
   * Rename a file to a new location in a branch.
   * Move file
   */
  async datasetFileMove(
    requestParameters: DatasetFileMoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileRead> {
    const response = await this.datasetFileMoveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetFileStat without sending the request
   */
  async datasetFileStatRequestOpts(
    requestParameters: DatasetFileStatRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetFileStat().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetFileStat().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling datasetFileStat().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/stat`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual file.
   * show file details
   */
  async datasetFileStatRaw(
    requestParameters: DatasetFileStatRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileReadWithUrl>> {
    const requestOptions = await this.datasetFileStatRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadWithUrlFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual file.
   * show file details
   */
  async datasetFileStat(
    requestParameters: DatasetFileStatRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileReadWithUrl> {
    const response = await this.datasetFileStatRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetStartUpload without sending the request
   */
  async datasetStartUploadRequestOpts(
    requestParameters: DatasetStartUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetStartUpload().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetStartUpload().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling datasetStartUpload().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Start upload and retrieve a temporary URL to upload a file to.
   * start file upload
   */
  async datasetStartUploadRaw(
    requestParameters: DatasetStartUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.datasetStartUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Start upload and retrieve a temporary URL to upload a file to.
   * start file upload
   */
  async datasetStartUpload(
    requestParameters: DatasetStartUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.datasetStartUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobCompleteUpload without sending the request
   */
  async jobCompleteUploadRequestOpts(
    requestParameters: JobCompleteUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobCompleteUpload().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobCompleteUpload().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobCompleteUpload().'
      );
    }

    if (requestParameters["uploadComplete"] == null) {
      throw new runtime.RequiredError(
        "uploadComplete",
        'Required parameter "uploadComplete" was null or undefined when calling jobCompleteUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UploadCompleteToJSON(requestParameters["uploadComplete"]),
    };
  }

  /**
   * Complete file upload and associate an uploaded object with a path.
   * complete file upload
   */
  async jobCompleteUploadRaw(
    requestParameters: JobCompleteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CompleteUploadRead>> {
    const requestOptions = await this.jobCompleteUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompleteUploadReadFromJSON(jsonValue)
    );
  }

  /**
   * Complete file upload and associate an uploaded object with a path.
   * complete file upload
   */
  async jobCompleteUpload(
    requestParameters: JobCompleteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CompleteUploadRead> {
    const response = await this.jobCompleteUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobDownload without sending the request
   */
  async jobDownloadRequestOpts(
    requestParameters: JobDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobDownload().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobDownload().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling jobDownload().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobDownload().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/files/download`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return download url of an individual file.
   * retrieve download url
   */
  async jobDownloadRaw(
    requestParameters: JobDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileDownload>> {
    const requestOptions = await this.jobDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileDownloadFromJSON(jsonValue));
  }

  /**
   * Return download url of an individual file.
   * retrieve download url
   */
  async jobDownload(
    requestParameters: JobDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileDownload> {
    const response = await this.jobDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobFileHistory without sending the request
   */
  async jobFileHistoryRequestOpts(
    requestParameters: JobFileHistoryRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobFileHistory().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobFileHistory().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobFileHistory().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/files/history`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Show history optionally filtered by file or directory.
   * show history
   */
  async jobFileHistoryRaw(
    requestParameters: JobFileHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CursorPageHistory>> {
    const requestOptions = await this.jobFileHistoryRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CursorPageHistoryFromJSON(jsonValue)
    );
  }

  /**
   * Show history optionally filtered by file or directory.
   * show history
   */
  async jobFileHistory(
    requestParameters: JobFileHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CursorPageHistory> {
    const response = await this.jobFileHistoryRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobFileLs without sending the request
   */
  async jobFileLsRequestOpts(requestParameters: JobFileLsRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobFileLs().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobFileLs().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobFileLs().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/files/ls`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a listing of files in a directory.
   * list files
   */
  async jobFileLsRaw(
    requestParameters: JobFileLsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CursorPageFileList>> {
    const requestOptions = await this.jobFileLsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CursorPageFileListFromJSON(jsonValue)
    );
  }

  /**
   * Return a listing of files in a directory.
   * list files
   */
  async jobFileLs(
    requestParameters: JobFileLsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CursorPageFileList> {
    const response = await this.jobFileLsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobFileStat without sending the request
   */
  async jobFileStatRequestOpts(
    requestParameters: JobFileStatRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobFileStat().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobFileStat().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling jobFileStat().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobFileStat().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/files/stat`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual file.
   * show file details
   */
  async jobFileStatRaw(
    requestParameters: JobFileStatRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileReadWithUrl>> {
    const requestOptions = await this.jobFileStatRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadWithUrlFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual file.
   * show file details
   */
  async jobFileStat(
    requestParameters: JobFileStatRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileReadWithUrl> {
    const response = await this.jobFileStatRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for jobStartUpload without sending the request
   */
  async jobStartUploadRequestOpts(
    requestParameters: JobStartUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobStartUpload().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobStartUpload().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling jobStartUpload().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobStartUpload().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Start upload and retrieve a temporary URL to upload a file to.
   * start file upload
   */
  async jobStartUploadRaw(
    requestParameters: JobStartUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.jobStartUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Start upload and retrieve a temporary URL to upload a file to.
   * start file upload
   */
  async jobStartUpload(
    requestParameters: JobStartUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.jobStartUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectDeleteDirectory without sending the request
   */
  async projectDeleteDirectoryRequestOpts(
    requestParameters: ProjectDeleteDirectoryRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDeleteDirectory().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDeleteDirectory().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectDeleteDirectory().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/directories/delete`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a directory and its content.
   * delete a directory
   */
  async projectDeleteDirectoryRaw(
    requestParameters: ProjectDeleteDirectoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.projectDeleteDirectoryRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a directory and its content.
   * delete a directory
   */
  async projectDeleteDirectory(
    requestParameters: ProjectDeleteDirectoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.projectDeleteDirectoryRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for projectDirectoryCopy without sending the request
   */
  async projectDirectoryCopyRequestOpts(
    requestParameters: ProjectDirectoryCopyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDirectoryCopy().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDirectoryCopy().'
      );
    }

    if (requestParameters["sourcePath"] == null) {
      throw new runtime.RequiredError(
        "sourcePath",
        'Required parameter "sourcePath" was null or undefined when calling projectDirectoryCopy().'
      );
    }

    if (requestParameters["destinationPath"] == null) {
      throw new runtime.RequiredError(
        "destinationPath",
        'Required parameter "destinationPath" was null or undefined when calling projectDirectoryCopy().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["sourcePath"] != null) {
      queryParameters["source_path"] = requestParameters["sourcePath"];
    }

    if (requestParameters["destinationPath"] != null) {
      queryParameters["destination_path"] = requestParameters["destinationPath"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/directories/copy`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Copy a file from one location to another in a branch.
   * copy directory
   */
  async projectDirectoryCopyRaw(
    requestParameters: ProjectDirectoryCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Directory>> {
    const requestOptions = await this.projectDirectoryCopyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DirectoryFromJSON(jsonValue));
  }

  /**
   * Copy a file from one location to another in a branch.
   * copy directory
   */
  async projectDirectoryCopy(
    requestParameters: ProjectDirectoryCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Directory> {
    const response = await this.projectDirectoryCopyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectDirectoryCreate without sending the request
   */
  async projectDirectoryCreateRequestOpts(
    requestParameters: ProjectDirectoryCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDirectoryCreate().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDirectoryCreate().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectDirectoryCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/directories/create`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Create an empty directory.
   * create directory
   */
  async projectDirectoryCreateRaw(
    requestParameters: ProjectDirectoryCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Directory>> {
    const requestOptions = await this.projectDirectoryCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DirectoryFromJSON(jsonValue));
  }

  /**
   * Create an empty directory.
   * create directory
   */
  async projectDirectoryCreate(
    requestParameters: ProjectDirectoryCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Directory> {
    const response = await this.projectDirectoryCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectDirectoryMove without sending the request
   */
  async projectDirectoryMoveRequestOpts(
    requestParameters: ProjectDirectoryMoveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDirectoryMove().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDirectoryMove().'
      );
    }

    if (requestParameters["sourcePath"] == null) {
      throw new runtime.RequiredError(
        "sourcePath",
        'Required parameter "sourcePath" was null or undefined when calling projectDirectoryMove().'
      );
    }

    if (requestParameters["destinationPath"] == null) {
      throw new runtime.RequiredError(
        "destinationPath",
        'Required parameter "destinationPath" was null or undefined when calling projectDirectoryMove().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["sourcePath"] != null) {
      queryParameters["source_path"] = requestParameters["sourcePath"];
    }

    if (requestParameters["destinationPath"] != null) {
      queryParameters["destination_path"] = requestParameters["destinationPath"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/directories/move`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Rename a directory to a new location in a branch.
   * move directory
   */
  async projectDirectoryMoveRaw(
    requestParameters: ProjectDirectoryMoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Directory>> {
    const requestOptions = await this.projectDirectoryMoveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DirectoryFromJSON(jsonValue));
  }

  /**
   * Rename a directory to a new location in a branch.
   * move directory
   */
  async projectDirectoryMove(
    requestParameters: ProjectDirectoryMoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Directory> {
    const response = await this.projectDirectoryMoveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectDownload without sending the request
   */
  async projectDownloadRequestOpts(
    requestParameters: ProjectDownloadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectDownload().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectDownload().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectDownload().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/download`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return download url of an individual file.
   * retrieve download url
   */
  async projectDownloadRaw(
    requestParameters: ProjectDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileDownload>> {
    const requestOptions = await this.projectDownloadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileDownloadFromJSON(jsonValue));
  }

  /**
   * Return download url of an individual file.
   * retrieve download url
   */
  async projectDownload(
    requestParameters: ProjectDownloadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileDownload> {
    const response = await this.projectDownloadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileAbortUpload without sending the request
   */
  async projectFileAbortUploadRequestOpts(
    requestParameters: ProjectFileAbortUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileAbortUpload().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileAbortUpload().'
      );
    }

    if (requestParameters["upload"] == null) {
      throw new runtime.RequiredError(
        "upload",
        'Required parameter "upload" was null or undefined when calling projectFileAbortUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
      body: UploadToJSON(requestParameters["upload"]),
    };
  }

  /**
   * Abort a file upload and remove any uploaded files.
   * abort file upload
   */
  async projectFileAbortUploadRaw(
    requestParameters: ProjectFileAbortUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.projectFileAbortUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Abort a file upload and remove any uploaded files.
   * abort file upload
   */
  async projectFileAbortUpload(
    requestParameters: ProjectFileAbortUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.projectFileAbortUploadRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for projectFileCompleteUpload without sending the request
   */
  async projectFileCompleteUploadRequestOpts(
    requestParameters: ProjectFileCompleteUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileCompleteUpload().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileCompleteUpload().'
      );
    }

    if (requestParameters["uploadComplete"] == null) {
      throw new runtime.RequiredError(
        "uploadComplete",
        'Required parameter "uploadComplete" was null or undefined when calling projectFileCompleteUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UploadCompleteToJSON(requestParameters["uploadComplete"]),
    };
  }

  /**
   * Complete the upload and associate the upload object with a path.
   * complete file upload
   */
  async projectFileCompleteUploadRaw(
    requestParameters: ProjectFileCompleteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CompleteUploadRead>> {
    const requestOptions = await this.projectFileCompleteUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompleteUploadReadFromJSON(jsonValue)
    );
  }

  /**
   * Complete the upload and associate the upload object with a path.
   * complete file upload
   */
  async projectFileCompleteUpload(
    requestParameters: ProjectFileCompleteUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CompleteUploadRead> {
    const response = await this.projectFileCompleteUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileCopy without sending the request
   */
  async projectFileCopyRequestOpts(
    requestParameters: ProjectFileCopyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileCopy().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileCopy().'
      );
    }

    if (requestParameters["sourcePath"] == null) {
      throw new runtime.RequiredError(
        "sourcePath",
        'Required parameter "sourcePath" was null or undefined when calling projectFileCopy().'
      );
    }

    if (requestParameters["destinationPath"] == null) {
      throw new runtime.RequiredError(
        "destinationPath",
        'Required parameter "destinationPath" was null or undefined when calling projectFileCopy().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["sourcePath"] != null) {
      queryParameters["source_path"] = requestParameters["sourcePath"];
    }

    if (requestParameters["destinationPath"] != null) {
      queryParameters["destination_path"] = requestParameters["destinationPath"];
    }

    if (requestParameters["srcRef"] != null) {
      queryParameters["src_ref"] = requestParameters["srcRef"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/copy`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Copy a file from one location to another in a branch.
   * copy file
   */
  async projectFileCopyRaw(
    requestParameters: ProjectFileCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileRead>> {
    const requestOptions = await this.projectFileCopyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadFromJSON(jsonValue));
  }

  /**
   * Copy a file from one location to another in a branch.
   * copy file
   */
  async projectFileCopy(
    requestParameters: ProjectFileCopyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileRead> {
    const response = await this.projectFileCopyRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileDelete without sending the request
   */
  async projectFileDeleteRequestOpts(
    requestParameters: ProjectFileDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileDelete().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileDelete().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectFileDelete().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/delete`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Delete a file.
   * delete a file
   */
  async projectFileDeleteRaw(
    requestParameters: ProjectFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.projectFileDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a file.
   * delete a file
   */
  async projectFileDelete(
    requestParameters: ProjectFileDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.projectFileDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for projectFileHistory without sending the request
   */
  async projectFileHistoryRequestOpts(
    requestParameters: ProjectFileHistoryRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileHistory().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileHistory().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/history`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Show history optionally filtered by file or directory.
   * show history
   */
  async projectFileHistoryRaw(
    requestParameters: ProjectFileHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CursorPageHistory>> {
    const requestOptions = await this.projectFileHistoryRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CursorPageHistoryFromJSON(jsonValue)
    );
  }

  /**
   * Show history optionally filtered by file or directory.
   * show history
   */
  async projectFileHistory(
    requestParameters: ProjectFileHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CursorPageHistory> {
    const response = await this.projectFileHistoryRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileLs without sending the request
   */
  async projectFileLsRequestOpts(
    requestParameters: ProjectFileLsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileLs().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileLs().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["cursor"] != null) {
      queryParameters["cursor"] = requestParameters["cursor"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/ls`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a listing of files in a directory.
   * list files
   */
  async projectFileLsRaw(
    requestParameters: ProjectFileLsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CursorPageFileList>> {
    const requestOptions = await this.projectFileLsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CursorPageFileListFromJSON(jsonValue)
    );
  }

  /**
   * Return a listing of files in a directory.
   * list files
   */
  async projectFileLs(
    requestParameters: ProjectFileLsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CursorPageFileList> {
    const response = await this.projectFileLsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileMove without sending the request
   */
  async projectFileMoveRequestOpts(
    requestParameters: ProjectFileMoveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileMove().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileMove().'
      );
    }

    if (requestParameters["sourcePath"] == null) {
      throw new runtime.RequiredError(
        "sourcePath",
        'Required parameter "sourcePath" was null or undefined when calling projectFileMove().'
      );
    }

    if (requestParameters["destinationPath"] == null) {
      throw new runtime.RequiredError(
        "destinationPath",
        'Required parameter "destinationPath" was null or undefined when calling projectFileMove().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["sourcePath"] != null) {
      queryParameters["source_path"] = requestParameters["sourcePath"];
    }

    if (requestParameters["destinationPath"] != null) {
      queryParameters["destination_path"] = requestParameters["destinationPath"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/move`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Rename a file to a new location in a branch.
   * move file
   */
  async projectFileMoveRaw(
    requestParameters: ProjectFileMoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileRead>> {
    const requestOptions = await this.projectFileMoveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadFromJSON(jsonValue));
  }

  /**
   * Rename a file to a new location in a branch.
   * move file
   */
  async projectFileMove(
    requestParameters: ProjectFileMoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileRead> {
    const response = await this.projectFileMoveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileRestart without sending the request
   */
  async projectFileRestartRequestOpts(
    requestParameters: ProjectFileRestartRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileRestart().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileRestart().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectFileRestart().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/restart`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Restart the file identification process.
   * restart file identification
   */
  async projectFileRestartRaw(
    requestParameters: ProjectFileRestartRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileReadWithUrl>> {
    const requestOptions = await this.projectFileRestartRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadWithUrlFromJSON(jsonValue));
  }

  /**
   * Restart the file identification process.
   * restart file identification
   */
  async projectFileRestart(
    requestParameters: ProjectFileRestartRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileReadWithUrl> {
    const response = await this.projectFileRestartRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileSetDescription without sending the request
   */
  async projectFileSetDescriptionRequestOpts(
    requestParameters: ProjectFileSetDescriptionRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileSetDescription().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileSetDescription().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectFileSetDescription().'
      );
    }

    if (requestParameters["description"] == null) {
      throw new runtime.RequiredError(
        "description",
        'Required parameter "description" was null or undefined when calling projectFileSetDescription().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/description`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: DescriptionToJSON(requestParameters["description"]),
    };
  }

  /**
   * Set file description.
   * set file description
   */
  async projectFileSetDescriptionRaw(
    requestParameters: ProjectFileSetDescriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Description>> {
    const requestOptions = await this.projectFileSetDescriptionRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DescriptionFromJSON(jsonValue));
  }

  /**
   * Set file description.
   * set file description
   */
  async projectFileSetDescription(
    requestParameters: ProjectFileSetDescriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Description> {
    const response = await this.projectFileSetDescriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileStartUpload without sending the request
   */
  async projectFileStartUploadRequestOpts(
    requestParameters: ProjectFileStartUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileStartUpload().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileStartUpload().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectFileStartUpload().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["branch"] != null) {
      queryParameters["branch"] = requestParameters["branch"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/upload`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Start upload and retrieve a temporary URL to upload a file to.
   * start file upload
   */
  async projectFileStartUploadRaw(
    requestParameters: ProjectFileStartUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Upload>> {
    const requestOptions = await this.projectFileStartUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UploadFromJSON(jsonValue));
  }

  /**
   * Start upload and retrieve a temporary URL to upload a file to.
   * start file upload
   */
  async projectFileStartUpload(
    requestParameters: ProjectFileStartUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Upload> {
    const response = await this.projectFileStartUploadRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for projectFileStat without sending the request
   */
  async projectFileStatRequestOpts(
    requestParameters: ProjectFileStatRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling projectFileStat().'
      );
    }

    if (requestParameters["projectId"] == null) {
      throw new runtime.RequiredError(
        "projectId",
        'Required parameter "projectId" was null or undefined when calling projectFileStat().'
      );
    }

    if (requestParameters["path"] == null) {
      throw new runtime.RequiredError(
        "path",
        'Required parameter "path" was null or undefined when calling projectFileStat().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["path"] != null) {
      queryParameters["path"] = requestParameters["path"];
    }

    if (requestParameters["ref"] != null) {
      queryParameters["ref"] = requestParameters["ref"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/projects/{project_id}/files/stat`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{project_id}",
      encodeURIComponent(String(requestParameters["projectId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual file.
   * show file details
   */
  async projectFileStatRaw(
    requestParameters: ProjectFileStatRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileReadWithUrl>> {
    const requestOptions = await this.projectFileStatRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => FileReadWithUrlFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual file.
   * show file details
   */
  async projectFileStat(
    requestParameters: ProjectFileStatRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileReadWithUrl> {
    const response = await this.projectFileStatRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const ProjectFileLsOrderByEnum = {
  Id: "id",
  Id2: "-id",
} as const;
export type ProjectFileLsOrderByEnum =
  (typeof ProjectFileLsOrderByEnum)[keyof typeof ProjectFileLsOrderByEnum];
